export const MONTHLY_SCORE_TRENDS = 'MONTHLY_SCORE_TRENDS';
export const CREDIT_LOCK = 'CREDIT_LOCK';
export const CREDIT_LOCK_UPSELL = 'CREDIT_LOCK_UPSELL';
export const CREDIT_REPORT = 'CREDIT_REPORT';
export const DISCREPANCIES = 'DISCREPANCIES';
